module.exports = "label#securityLabel {\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/partials/security-modal/security-modal.component.scss
// module id = ./src/app/components/partials/security-modal/security-modal.component.scss
// module chunks = main